import { cn } from '../../lib/cn';
import type { AIProviderRow } from '../../platformadmin/framework';

type Props = { providers?: AIProviderRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'primary': return 'bg-brand-100 text-brand-700 dark:bg-brand-950 dark:text-brand-300';
    case 'fallback': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function AIGovernancePanel({ providers = [] }: Props) {
  return (
    <div className="space-y-2">
      {providers.map((p) => (
        <div key={p.provider} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{p.provider}</p>
            <p className="text-xs text-slate-500">{p.cost} · {p.latency} avg</p>
          </div>
          <span className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(p.status))}>
            {p.status}
          </span>
        </div>
      ))}
    </div>
  );
}
